import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { WarningAmber, Event, Error } from '@mui/icons-material';
import { Box, darken, IconButton, lighten, styled, Tooltip, Typography, } from '@mui/material';
import { memo, useCallback } from 'react';
const Fab = styled(IconButton)(({ theme }) => {
    return {
        width: 35,
        height: 35,
        backgroundColor: 'transparent',
        '&:hover': {
            color: theme.palette.mode == 'dark'
                ? lighten(theme.palette.text.secondary, 0.9)
                : darken(theme.palette.text.secondary, 0.8),
            backgroundColor: 'transparent',
        },
        [theme.breakpoints.down('xs')]: {
            color: theme.palette.common.white,
            '&:hover': {
                color: darken(theme.palette.common.white, 0.3),
            },
        },
    };
});
export var priopityType;
(function (priopityType) {
    priopityType[priopityType["event"] = 0] = "event";
    priopityType[priopityType["warning"] = 1] = "warning";
    priopityType[priopityType["error"] = 2] = "error";
})(priopityType || (priopityType = {}));
const priopityList = [
    {
        icon: _jsx(Event, { color: "info" }),
        label: 'Событие',
        value: priopityType.event,
    },
    {
        icon: _jsx(WarningAmber, { color: "warning" }),
        label: 'Тревога',
        value: priopityType.warning,
    },
    {
        icon: _jsx(Error, { color: "error" }),
        label: 'Авария',
        value: priopityType.error,
    },
];
export const PriopityListSwitcher = memo(function PriopityListSwitcher(props) {
    const { value, onChange } = props;
    const chosen_priority = value ?? priopityType.event;
    const onChangeTheme = useCallback(() => {
        const new_theme = chosen_priority === priopityType.error
            ? priopityType.event
            : chosen_priority + 1;
        onChange(new_theme);
    }, [onChange, chosen_priority]);
    const priopity = priopityList[chosen_priority];
    return (_jsx(Tooltip, { title: priopity.label, children: _jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "center", flexWrap: "wrap", children: [_jsx(Fab, { onClick: onChangeTheme, children: priopity.icon }), _jsx(Typography, { variant: "subtitle1", color: "warning", ml: 1, children: priopity.label })] }) }));
});
